import searchIcon from '@disy/cadenza-icons/search.svg';

import type { SelectInitializationOptions } from 'ui/select/select';
import { Select } from 'ui/select/select';
import { createIconButton } from 'ui/button/button';

import { icon } from 'cadenza/utils/icon/icon';

import i18n from './messages.properties';

export function createSelectWithSearchButton(options?: Omit<SelectInitializationOptions, 'elementLeft'>) {
  const select: Select = new Select({
    ...options,
    elementLeft: createIconButton(icon(searchIcon), i18n('searchButton'), {
      variant: 'borderless',
      tabIndex: -1,
      onclick: () => select.open(),
    }),
  });
  const placeholder = options?.placeholder;
  if (placeholder) {
    select.searchInput?.setAttribute('aria-label', typeof placeholder === 'string' ? placeholder : placeholder.text);
  }
  return select;
}
